import { render } from "./gallery.vue?vue&type=template&id=d0658446"
import script from "./gallery.vue?vue&type=script&lang=js"
export * from "./gallery.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Tomer\\projects\\pmaculator-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__